const asset = require('./asset');
const isResolvedCollection = require('../contentful/is-resolved-collection');
const isResolvedResource = require('../contentful/is-resolved-resource');
const modelTransformer = require('./model');
const equipmentLevelTransformer = require('./equipmentLevel').default;

const createEntryLink = (entry) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Entry',
      id: entry.id
    }
  };
};

const createAssetLink = (asset) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Asset',
      id: asset.id
    }
  };
};

module.exports = {
  contentfulToInternal(entry) {
    // console.log('color', entry);
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: null,

      name: entry.fields.name['nb-NO'],
      type: (entry.fields.type ? entry.fields.type['nb-NO'] : null),
      colorGroup: (entry.fields.colorGroup ? entry.fields.colorGroup['nb-NO'] : null),
      // displayname: (entry.fields.displayname ? entry.fields.displayname['nb-NO'] : ""),
      externalId: (entry.fields.externalId ? entry.fields.externalId['nb-NO'] : null),
      reference: (entry.fields.reference ? entry.fields.reference['nb-NO'] : null),
      description: (entry.fields.description ? entry.fields.description['nb-NO'] : ''),
      priceAdjustment: (entry.fields.priceAdjustment ? entry.fields.priceAdjustment['nb-NO'] : ''),
      model: null,
      mainImage: null,
      silhouetteImage: null,
      equipmentLevelWhitelist: [],
      specialOrder: (entry.fields.specialOrder ? entry.fields.specialOrder['nb-NO'] : null),

      allowedColorGroups: []
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;
    }

    // Handle model link:
    if (entry.fields.model && entry.fields.model['nb-NO'] && isResolvedResource(entry.fields.model['nb-NO'])) {
      result.model = modelTransformer.contentfulToInternal(entry.fields.model['nb-NO']);
    }

    if (entry.fields.equipmentLevelWhitelist && entry.fields.equipmentLevelWhitelist['nb-NO'] && isResolvedCollection(entry.fields.equipmentLevelWhitelist['nb-NO'])) {
      result.equipmentLevelWhitelist = entry.fields.equipmentLevelWhitelist['nb-NO'].map(equipmentLevelTransformer.contentfulToInternal);
    }

    if (entry.fields.mainImage && entry.fields.mainImage['nb-NO'] && isResolvedResource(entry.fields.mainImage['nb-NO'])) {
      result.mainImage = asset.contentfulToInternal(entry.fields.mainImage['nb-NO']);
    }

    if (entry.fields.silhouetteImage && entry.fields.silhouetteImage['nb-NO'] && isResolvedResource(entry.fields.silhouetteImage['nb-NO'])) {
      result.silhouetteImage = asset.contentfulToInternal(entry.fields.silhouetteImage['nb-NO']);
    }

    // Get allowedColorGroups
    const colorGroupField = entry.sys.contentType.fields?.find((field) => field.id === 'colorGroup');
    if (colorGroupField) {
      result.allowedColorGroups = colorGroupField.validations[0].in;
    }

    return result;
  },

  internalToContentful(color) {
    const result = {
      fields: {
        name: {
          'nb-NO': color.name
        },
        colorGroup: null,
        type: null,
        externalId: null,
        reference: null,
        description: null,
        priceAdjustment: null,
        model: null,
        mainImage: null,
        silhouetteImage: null,
        equipmentLevelWhitelist: null,
        specialOrder: {
          'nb-NO': color.specialOrder === true
        }
      }
    };

    if (color.colorGroup) {
      result.fields.colorGroup = {
        'nb-NO': color.colorGroup
      };
    }

    if (color.type) {
      result.fields.type = {
        'nb-NO': color.type
      };
    }

    if (color.externalId) {
      result.fields.externalId = {
        'nb-NO': color.externalId
      };
    }

    if (color.reference) {
      result.fields.reference = {
        'nb-NO': color.reference
      };
    }

    if (color.description) {
      result.fields.description = {
        'nb-NO': color.description
      };
    }

    if (color.priceAdjustment) {
      result.fields.priceAdjustment = {
        'nb-NO': parseInt(color.priceAdjustment, 10)
      };
    }

    if (color.description) {
      result.fields.description = {
        'nb-NO': color.description
      };
    }

    // Model link:
    if (typeof color.model !== 'undefined') {
      result.fields.model = {
        'nb-NO': color.model ? createEntryLink(color.model) : null
      };
    }

    // equipmentLevel link:
    if (color.equipmentLevelWhitelist) {
      result.fields.equipmentLevelWhitelist = {
        'nb-NO': color.equipmentLevelWhitelist.map(createEntryLink)
      };
    }

    // Images:
    if (color.mainImage) {
      result.fields.mainImage = {
        'nb-NO': createAssetLink(color.mainImage)
      };
    }

    if (color.silhouetteImage) {
      result.fields.silhouetteImage = {
        'nb-NO': createAssetLink(color.silhouetteImage)
      };
    }

    return result;
  }
};
